import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetRegisterOTP(payload) {
    return Api().post(`${API_VERSION}/webapp/getregisterotp`, payload);
  },
  Register(payload) {
    return Api().post(`${API_VERSION}/webapp/register`, payload);
  },
  GetLoginOTP(payload) {
    return Api().post(`${API_VERSION}/webapp/getloginotp`, payload);
  },
  // Login(payload) {
  //     return Api().post(`${API_VERSION}/webapp/login`, payload)
  // },
  SocialLogin(payload) {
    return Api().post(`${API_VERSION}/webapp/sociallogin`, payload);
  },
  GetUsers(payload) {
    let query = "";
    if (Object.keys(payload).length > 0) {
      let urlparams = new URLSearchParams();
      for (const key in payload) {
        if (payload[key]) {
          urlparams.append(key, payload[key]);
        }
      }
      if ([...urlparams.entries()].length > 0) {
        query += `?${urlparams.toString()}`;
      }
      // query += `?search=${payload.search}`;
      query += `?${urlparams.toString()}`;
    }
    return Api().get(`/admin/user/${query}`, payload);
    // return Api().get(`${API_VERSION}/admin/users/${query}`, payload);
  },
  GetUser(payload) {
    return Api().get(`/admin/user/${payload.user_id}`, payload);
    // return Api().get(`${API_VERSION}/admin/user/${payload.user_id}`, payload);
  },
  EditUser(payload) {
    // return Api().post(
    //   `${API_VERSION}/admin/user/edit/${payload.user_id}`,
    //   payload
    // );
    return Api().put(`/admin/user/${payload.user_id}`, payload);
  },
  Login(payload) {
    //return Api().post(`${API_VERSION}/admin/login`, payload);
    return Api().post(`/login`, payload);
  },
  AddAdmin(payload) {
    return Api().post(`/admin/add-admin`, payload);
  }
};
